import { render } from "./Account.vue?vue&type=template&id=3b242522&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=3b242522&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b242522"]])

export default __exports__